import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/services/filing-options`;
